import React from "react";
import './assets/scss/modal.scss';
import PropTypes from "prop-types";

export default class MessagePopup extends React.Component {
    onClose = e => {
        this.props.onClose && this.props.onClose(e);
    };

    onBack = e => {
        this.props.onBack && this.props.onBack(e);
    }

    render() {
        if (!this.props.show) {
            return null;
        }

        return (
            <div id="modal" className={"modal" + " " + this.props.setClassName} onClick={e => this.props.onClose(e)}>
                <div class="modal-content" onClick={e => e.stopPropagation()}>
                    {this.props.showBackButton ?
                        <button onClick={this.onBack} className="toggle-button toggle-button-back"></button> :
                        null
                    }
                    <button class="toggle-button" onClick={this.onClose}>
                    </button>
                    {this.props.children}
                </div>
            </div>
        );
    }
}
MessagePopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired
};